<template>
  <div>
    <div class="earned_container">
      <div class="points" v-if="achievementInfo.prizeType === prizeTypes.POINTS">
        <img src="static/images/bonus_points.svg" alt="">
        <p>+{{ achievementInfo.prizeValue }} {{ getTranslations.home_modals_achievements_reward_points }}</p>
      </div>
      <div class="spin loot_box" v-if="achievementInfo.prizeType === prizeTypes.SPINNING_WHEEL">
        <span v-if="achievementInfo.completed === true"><img src="static/images/wheel.svg" alt=""></span>
        <span v-else><img src="static/images/free_game_assets/bonus_game_generic.svg" alt=""></span>
        <div class="spins_number">
          <span>+{{ achievementInfo.prizeValue }}</span>
        </div>
        <a href="#"
           :class="['btn2 btn2_modal btn2--std btn2--small', { deactivated: isAlreadyRedeemed }]"
           v-if="!disablePlay"
           @click.prevent="spin()">
          {{ getTranslations.home_modals_achievements_reward_spin }}
        </a>
      </div>
      <div class="spin loot_box" v-if="achievementInfo.prizeType === prizeTypes.LOOT_BOX">
        <span v-if="achievementInfo.completed === true"><img src="static/images/free_game_assets/loot_box.svg" alt=""></span>
        <span v-else><img src="static/images/free_game_assets/bonus_game_generic.svg" alt=""></span>
        <div class="spins_number">
          <span>+{{ achievementInfo.prizeValue }}</span>
        </div>
        <a href="#"
           :class="['btn2 btn2_modal btn2--std btn2--small', { deactivated: isAlreadyRedeemed }]"
           v-if="!disablePlay"
           @click.prevent="open()">
          {{ getTranslations.home_modals_achievements_reward_open }}
        </a>
      </div>
      <div class="spin loot_box" v-if="achievementInfo.prizeType === prizeTypes.LIGHT_THE_LANTERNS">
        <span v-if="achievementInfo.completed === true"><img src="static/images/free_game_assets/lattern.svg" alt=""></span>
        <span v-else><img src="static/images/free_game_assets/bonus_game_generic.svg" alt=""></span>
        <div class="spins_number">
          <span>+{{ achievementInfo.prizeValue }}</span>
        </div>
        <a href="#"
           :class="['btn2 btn2_modal btn2--std btn2--small', { deactivated: deactivate }]"
           v-if="!disablePlay"
           @click.prevent="play_lattern()">
          {{ getTranslations.home_modals_achievements_reward_lattern }}
        </a>
      </div>
      <div class="spin loot_box" v-if="achievementInfo.prizeType === prizeTypes.PUZZLE">
        <span v-if="achievementInfo.completed === true"><img src="static/images/free_game_assets/puzzle.svg" alt=""></span>
        <span v-else><img src="static/images/free_game_assets/bonus_game_generic.svg" alt=""></span>
        <div class="spins_number">
          <span>+{{ achievementInfo.prizeValue }}</span>
        </div>
        <a href="#"
           :class="['btn2 btn2_modal btn2--std btn2--small', { deactivated: deactivate }]"
           v-if="!disablePlay"
           @click.prevent="play_puzzle()">
          {{ getTranslations.home_modals_achievements_reward_puzzle }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import SpinWheel from '@/components/home/modals/achievements/SpinWheel';
import LootBox from '@/components/home/modals/achievements/LootBox';
import PreGameLanterns from '../game/addongamelanterns/modals/PreGameLanterns';
import PreGameAddOnPuzzle from '../game/addongamepuzzle/PreGameAddOnPuzzle';

export default {
  name: 'achievement-reward',
  emits: ['read'],
  components: {
    SpinWheel,
    LootBox,
    PreGameAddOnPuzzle,
    PreGameLanterns,
  },
  props: {
    achievementInfo: Object,
    categoryName: String,
    disablePlay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPrizeInfo: false,
      prizeTypes: {
        POINTS: 'POINTS',
        SPINNING_WHEEL: 'SPINNING_WHEEL',
        LOOT_BOX: 'LOOT_BOX',
        LIGHT_THE_LANTERNS: 'LIGHT_THE_LANTERNS',
        PUZZLE: 'PUZZLE',
      },
    };
  },
  created() {
    if (this.achievementInfo.prizeType === this.prizeTypes.LIGHT_THE_LANTERNS || this.achievementInfo.prizeType === this.prizeTypes.PUZZLE) {
      const payload = { achievementName: `${this.achievementInfo.categoryName}_${this.achievementInfo.achievementLevelName}` };
      this.updateDBonusAddOnGames(payload);
    }
  },
  methods: {
    ...mapActions('profile', [
      'updateDBonusAddOnGames',
    ]),
    ...mapMutations('profile', [
      'setRedeemedNotification',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('game', [
      'setBonusAddOnGameDataFromAchievements',
    ]),
    spin() {
      this.storeModalForHomePage(SpinWheel);
    },
    open() {
      this.storeModalForHomePage(LootBox);
    },
    play_lattern() {
      this.setBonusAddOnGameDataFromAchievements(`${this.achievementInfo.categoryName}_${this.achievementInfo.achievementLevelName}`);
      this.storeModalForHomePage(PreGameLanterns);
    },
    play_puzzle() {
      this.setBonusAddOnGameDataFromAchievements(`${this.achievementInfo.categoryName}_${this.achievementInfo.achievementLevelName}`);
      this.storeModalForHomePage(PreGameAddOnPuzzle);
    },
  },
  beforeDestroy() {
    if (this.achievementInfo.prizeType !== this.prizeTypes.SPINNING_WHEEL || this.achievementInfo.prizeType !== this.prizeTypes.LOOT_BOX || this.achievementInfo.prizeType !== this.prizeTypes.LIGHT_THE_LANTERNS || this.achievementInfo.prizeType !== this.prizeTypes.PUZZLE || this.isAlreadyRedeemed) {
      this.setRedeemedNotification(this.checkedNotificationId);
      this.$emit('read', this.checkedNotificationId);
    }
  },
  computed: {
    ...mapState('profile', [
      'achievementNotificationData',
      'checkedNotificationId',
    ]),
    ...mapState('game', [
      'addOnBonusGameData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    deactivate() {
      if (this.addOnBonusGameData.achievementName === 'ALREADY_PLAYED') {
        return true;
      }
      return false;
    },
    isAlreadyRedeemed() {
      const { categoryName, achievementLevelName } = this.achievementInfo;
      const matchingNotifications = (this.achievementNotificationData || []).filter(notification => notification.text === `${categoryName}_${achievementLevelName}`);
      if (!matchingNotifications.length) {
        return false;
      }
      const { readStatus } = matchingNotifications[0];
      return readStatus;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/achievements/AchievementReward.vue